// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contact-form__input-field{margin-bottom:1rem}.contact-form__submit-button{margin:2rem auto;padding:0 2rem;width:100%}.contact-form .error-message{display:block;font-size:.875rem;line-height:130%;margin:5px 2px 0}.contact-form__error{max-width:540px;padding:0 20px;text-align:center}.contact-form__button{margin-top:40px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
